module.exports = __webpack_public_path__ + "static/media/Readytogo.c68570c6.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Readytogo.PNG
// module id = 2305
// module chunks = 0